import { DirectUpload } from "@rails/activestorage";

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function UploadFile(
  files: File[],
  token: string,
  onProgress?: (progress: number) => void
): Promise<string[]> {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000";
  const url = `${baseUrl}/direct_uploads?token=${token}`;

  // Use Rails DirectUpload helper which computes correct Base64 MD5 checksum
  const uploadOne = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const delegate = {
        directUploadWillStoreFileWithXHR: (xhr: XMLHttpRequest) => {
          if (xhr.upload && onProgress) {
            xhr.upload.addEventListener("progress", (event: ProgressEvent) => {
              if (event.lengthComputable) {
                const pct = Math.round((event.loaded / event.total) * 100);
                onProgress(pct);
              }
            });
          }
        },
      } as any;

      const upload = new DirectUpload(file, url, delegate);
      upload.create((error: unknown, blob: any) => {
        if (error) {
          console.error("Upload error:", error);
          reject(error);
        } else {
          resolve(blob.signed_id as string);
        }
      });
    });

  return Promise.all(files.map((f) => uploadOne(f)));
}

// Converts a string to Title Case (e.g., "hello world" => "Hello World")
export function toTitleCase(str: string | null | undefined): string {
  if (!str) return "";
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}
